<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  created () {
  }
}
</script>

<style lang="scss">
  #app{
    // min-width: 1280px;
    overflow: auto;
  }
</style>
